import Notification from "~/models/notifications/notification";
import ObjectModelTriggerRecipient from "~/models/objectModels/objectModelTriggerRecipient";
import Recipient from "~/models/notifications/recipient";
import {DurationUnit} from "~/enums/durationUnit";
import {NotificationDeliveryMethod} from "~/enums/notificationDeliveryMethod";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import {RelationType} from "~/models/relationType";
import RecipientFactory from "~/models/notifications/recipientFactory";
import {InstanceHelper} from "~/helpers/instanceHelper";
import {ArrayHelper} from "~/helpers/arrayHelper";
import {ObjectHelper} from "~/helpers/objectHelper";
import {RecipientType} from "~/enums/recipentType";
export default class ObjectModelTriggerNotification extends Notification{
  object_model_trigger_recipients?: { [key: string]: ObjectModelTriggerRecipient } = {};
  except = ['recipients', 'createEmbeddedObject', 'object_model_trigger_recipients'];

  get rootName(): string {
    return 'object_model_trigger_notifications';
  }
  get recipientClass(){
    return ObjectModelTriggerRecipient
  }

  static repo: IRepo<ObjectModelTriggerNotification> = new Repo<ObjectModelTriggerNotification>('object_model_trigger_notifications', ObjectModelTriggerNotification);

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'object_model_trigger_recipients': { type: ObjectModelTriggerRecipient, relationType: RelationType.dictionary }
    };
  }
  get toRecipientsArray(): ObjectModelTriggerRecipient[] {
    return ObjectHelper.toArray(this.object_model_trigger_recipients);
  }


  get childRootName(): string {
    return 'object_model_trigger_recipients';
  }

  get recipientsArray(): ObjectModelTriggerRecipient[] {
    return ObjectHelper.toArray(this.object_model_trigger_recipients);
  }


}